import apiClient from '@/plugins/axios'

export default {
  getFiles(url, id) {
    return apiClient.get(`${url}/${id}`)
  },

  getFile(url) {
    return apiClient.get(`${url}`)
  },

  updateFile(url, payload) {
    return apiClient.put(`${url}`, payload)
  },

  deleteFile(url, payload) {
    return apiClient.post(`${url}/delete`, payload)
  },

}



// WEBPACK FOOTER //
// ./src/views/OrquestraFiles/_services/index.js